module.exports = __webpack_public_path__ + "desktop-phone-format-2.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/js/components/pages/newLandingPage/block-devices/assets/desktop-phone-format-2.mp4
// module id = 1159
// module chunks = 10